import * as React from 'react';
import { useGetStatusImageUrl } from 'src/hooks';
import { Dimension } from 'src/types';
import { useCurrentZoneSandboxObj } from 'src/components/ZoneSandbox/ListSandboxDevices/useCurrentZoneSandboxObj';
import { createKonvaImageFn } from '../utils';

export const useGetStageImage = ({
  width,
  height,
  onLoad,
}: Dimension & {
  onLoad: () => void;
}) => {
  const { data, isLoading, imageDataLoading, imageData } = useGetStatusImageUrl({ fetchImageData: true });
  const currentZoneSandboxObj = useCurrentZoneSandboxObj();

  /**
   * Create image object for status image
   */
  const image = React.useMemo(
    () =>
      createKonvaImageFn({
        width,
        height,
        imgUrl: currentZoneSandboxObj?.status_image_url || data?.[0]?.url || '',
        imgBlob: imageData,
        onLoad: onLoad,
      }),
    [data, imageData, width, height, currentZoneSandboxObj?.status_image_url, onLoad]
  );

  return {
    image,
    imageLoading: isLoading || imageDataLoading,
    imageData,
  };
};
